export const USER_INITIAL_FORM = {
  name: "",
  email: "",
  password: "",
  phone: "",
  role: "staff",
};

export const USER_INITIAL_FILTERS = {
  name: "",
  email: "",
  phone: "",
  role: "",
  isVerified: "",
};

export const USER_PAGE_SIZE = 10;

export const USER_ROLES = [
  {
    value: "admin",
    label: "Admin",
  },
  {
    value: "staff",
    label: "Staff",
  },
  {
    value: "users",
    label: "User",
  },
];
